import React,{lazy} from 'react'
import { Route } from 'react-router-dom';
import ChangePassword from '../pages/Dashboard/ChangePassword.js';
import AlertSettings from "../pages/Dashboard/AlertSettings";
const RulesTemplateManager   = lazy(() => import('../pages/Promotions/RulesTemplateManager.jsx'));
const DirectorsManager       = lazy(() => import('../pages/Dashboard/DirectorsManager.jsx'));

const TestSchedulePage = lazy(() => import('../pages/Dashboard/TestSchedulePage.js'));
const AddPerson = lazy(() => import('../pages/Dashboard/AddPerson.js'));
const AllPersonDetails = lazy(() => import('../pages/Dashboard/AllPersonDetails.js'));
const Setting = lazy(() => import('../pages/Dashboard/Setting.js'));
const Payment = lazy(() => import('../pages/Dashboard/Payment.js'));

const AllTeamsDetails = lazy(() => import('../pages/Dashboard/AllTeamsDetails.js'));
const AddTeams = lazy(() => import('../pages/Dashboard/AddTeams.js'));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const AllTournament = lazy(() => import("../pages/Dashboard/AllTournament.js"));
const AddTournament = lazy(() => import("../pages/Dashboard/AddTournament.js"));
const AllTournamentDetails = lazy(() => import("../pages/Dashboard/AllTournamentDetails.js"));
const AllPerson = lazy(() => import("../pages/Dashboard/AllPerson.js"));
const AllTeam = lazy(() => import("../pages/Dashboard/AllTeam.js"));
const AddVenues = lazy(() => import("../pages/Dashboard/AddVenue.js"));
const AllVenues = lazy(() => import("../pages/Dashboard/AllVenus.js"));
const AddDivision = lazy(() => import("../pages/Dashboard/AddDivision.js"));
const AllDivision = lazy(() => import("../pages/Dashboard/AllDivision.js"));
const AllDivisionDetails = lazy(() => import("../pages/Dashboard/AllDivisionDetails.js"));
const AllVenusDetails = lazy(() => import("../pages/Dashboard/AllVenusDetails.js"));
const RegisterTeam = lazy(() => import('../pages/Payment/RegisterTeam.jsx'));

// Sport Routes
const AddSport = lazy(() => import("../pages/Dashboard/AddSport.js"));
const AllSport = lazy(() => import("../pages/Dashboard/AllSport.js"));
const SportDetails = lazy(() => import("../pages/Dashboard/SportDetails.js"));

// Division Master Routes
const AddDivisionMaster = lazy(() => import("../pages/Dashboard/AddDivisionMaster.js"));
const AllDivisionMaster = lazy(() => import("../pages/Dashboard/AllDivisionMaster.js"));
const DivisionMasterDetails = lazy(() => import("../pages/Dashboard/DivisionMasterDetails.js"));
const AddRosterMember = lazy(() => import('../pages/Dashboard/AddRosterMember.js'));
const TeamRoster = lazy(() => import('../pages/Dashboard/TeamRoster.js'));

// ── NEW: Promotions ──────────────────────────────────────────────────────────
const CouponManager          = lazy(() => import('../pages/Promotions/CouponManager.jsx'));
const TournamentRulesManager = lazy(() => import('../pages/Promotions/TournamentRulesManager.jsx'));

// ── DRAFT TOURNAMENT PAGES (NEW) ──────────────────────────────────────────────
const DraftPackagesPage    = lazy(() => import('../pages/Dashboard/DraftPackagesPage.js'));
const DraftRegistrationsPage = lazy(() => import('../pages/Dashboard/DraftRegistrations.jsx'));
const DraftCancellationsPage = lazy(() => import('../pages/Dashboard/DraftCancellationsPage.js'));







const AdminRoutes = (
    <>
        <Route exact path='/dashboard' element={<Dashboard />}></Route>
        <Route exact path='/dashboard/allteams' element={<AllTeam />}></Route>
        <Route exact path='/dashboard/addteams' element={<AddTeams />}></Route>
        <Route exact path='/dashboard/allteams/:id' element={<AllTeamsDetails />}></Route>
        <Route exact path='/dashboard/alltournaments' element={<AllTournament />}></Route>
        <Route exact path='/dashboard/tournamentsdetails/:id' element={<AllTournamentDetails />}></Route>
        <Route exact path='/dashboard/payment/history' element={<Payment />}></Route>
        <Route exact path='/dashboard/addtournaments' element={<AddTournament />}></Route>
        <Route exact path='/dashboard/addvenue' element={<AddVenues />}></Route>
        <Route exact path='/dashboard/allvenue' element={<AllVenues />}></Route>
        <Route exact path='/dashboard/allvenue/:id' element={<AllVenusDetails />}></Route>
        <Route exact path='/dashboard/allpersons' element={<AllPerson />}></Route>
        <Route exact path='/dashboard/allpersons/:id' element={<AllPersonDetails />}></Route>
        <Route exact path='/dashboard/addperson' element={<AddPerson />}></Route>
        <Route exact path='/dashboard/addivision' element={<AddDivision />}></Route>
        <Route exact path='/dashboard/alldivisions' element={<AllDivision />}></Route>
        <Route exact path='/dashboard/alldivisions/:id' element={<AllDivisionDetails />}></Route>
        <Route exact path='/dashboard/user/setting' element={<Setting />}></Route>
        <Route exact path='/dashboard/user/change-password' element={<ChangePassword />}></Route>
        <Route exact path="/dashboard/alert-settings" element={<AlertSettings />} />

                <Route exact path='/dashboard/test-schedule' element={<TestSchedulePage />}></Route>

                {/* Sport Routes */}
                <Route exact path='/dashboard/addsport' element={<AddSport />}></Route>
                <Route exact path='/dashboard/allsports' element={<AllSport />}></Route>
                <Route exact path='/dashboard/allsports/:id' element={<SportDetails />}></Route>
                
                {/* Division Master Routes */}
                <Route exact path='/dashboard/adddivisionmaster' element={<AddDivisionMaster />}></Route>
                <Route exact path='/dashboard/alldivisionmasters' element={<AllDivisionMaster />}></Route>
                <Route exact path='/dashboard/alldivisionmasters/:id' element={<DivisionMasterDetails />}></Route>

        <Route exact path='/dashboard/registerteam/:id' element={<RegisterTeam />}></Route>
                <Route exact path='/dashboard/team/:teamId/add-roster-member' element={<AddRosterMember />}></Route>
                <Route exact path='/dashboard/team/:teamId/roster' element={<TeamRoster />}></Route>


               {/* ── Promotions ── */}
        <Route exact path='/dashboard/coupons'                  element={<CouponManager />} />

        {/* Basic Tables — Rules */}
        <Route exact path='/dashboard/tournament-rules'         element={<TournamentRulesManager />} />
        <Route exact path='/dashboard/rules-templates'          element={<RulesTemplateManager />} />
        <Route exact path='/dashboard/directors'                element={<DirectorsManager />} />


        {/* ── DRAFT TOURNAMENT ROUTES (NEW) ────────────────────────────────────── */}
        <Route exact path='/dashboard/draft/packages'       element={<DraftPackagesPage />} />
        <Route exact path='/dashboard/draft/registrations'  element={<DraftRegistrationsPage />} />
        <Route exact path='/dashboard/draft/cancellations'  element={<DraftCancellationsPage />} />
        {/* Scoped to a specific tournament — linked from AllTournamentDetails */}
        <Route exact path='/dashboard/draft/packages/:tournamentId'      element={<DraftPackagesPage />} />
        <Route exact path='/dashboard/draft/registrations/:tournamentId' element={<DraftRegistrationsPage />} />


        
    </>
)

export default AdminRoutes